import qs from "qs";
import { useStrapiApi } from "~/uses/useMyFetch";

export const fetchReviews = (params, pagination, excludedFields = []) => {
  const query = qs.stringify({
    sort: ["createdAt:desc"],
    ...params,
    pagination,
    fields: [
      "rating",
      "content",
      "pros",
      "cons",
      "reply",
      "name",
      "isPurchased",
      "createdAt",
    ].filter((field) => !excludedFields.includes(field)),
  });

  return useStrapiApi(`/product/reviews?${query}`);
};
